export const events: any = {
  VISITS: {
    VISIT_SALE: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_SALE_NEW: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
    },
    VISIT_OFFICE_SALE: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_OFFICE_SALE_NEW: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_CANCELLED_SALE: {
      confirmation: ["visitor", "owner", "current_renter"],
    },
    VISIT_CANCELLED_SALE_NEW: {
      confirmation: ["visitor", "owner", "current_renter"],
    },
    VISITDAY_SALE: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISITDAY_SALE_NEW: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_RENT: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      rental_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_CANCELLED_RENT: {
      confirmation: ["visitor", "owner", "current_renter"],
    },
    VISITDAY_RENT: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_GENERIC_OFFICE: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_GENERIC_ONSITE: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
      in_option: ["visitor", "owner", "current_renter"],
      reserved: ["visitor", "owner", "current_renter"],
      sales_agreement: ["visitor", "owner", "current_renter"],
    },
    VISIT_GENERIC_COMPROMIS: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
    },
    VISIT_GENERIC_HUURCONTRACT: {
      confirmation: ["visitor", "owner", "current_renter"],
      reminder1: ["visitor", "owner", "current_renter"],
      reminder2: ["visitor", "owner", "current_renter"],
      reminder3: ["visitor", "owner", "current_renter"],
      reminder_sms: ["visitor", "owner", "current_renter"],
      after_appointment: ["visitor", "owner", "current_renter"],
      after_appointment1: ["visitor", "owner", "current_renter"],
      after_appointment2: ["visitor", "owner", "current_renter"],
      after_appointment3: ["visitor", "owner", "current_renter"],
      after_appointment4: ["visitor", "owner", "current_renter"],
    },
    VISIT_CANCELLED: {
      confirmation: ["visitor", "owner", "current_renter"],
    },
  },
  VISIT_REQUEST: {
    VISIT_REQUEST_SALE: {
      visit_request: ["visitor"],
      follow_up1: ["visitor"],
      follow_up2: ["visitor"],
      reserved: ["visitor"],
      in_option: ["visitor"],
      sales_agreement: ["visitor"],
    },
    VISIT_REQUEST_RENT: {
      visit_request: ["visitor"],
      follow_up1: ["visitor"],
      follow_up2: ["visitor"],
      reserved: ["visitor"],
      in_option: ["visitor"],
      rental_agreement: ["visitor"],
    },
  },
  INBOUNDLEADS: {
    ESTIMATION_BUY_IN: {
      confirmation: ["owner"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      after_appointment: ["owner", "representative"],
      after_appointment_no_deal1: ["owner"],
      after_appointment_no_deal2: ["owner"],
      after_appointment_no_deal3: ["owner"],
      follow_up1: ["representative"],
      follow_up2: ["representative"],
      follow_up3: ["representative"],
      follow_up4: ["representative"],
    },
    ESTIMATION_RENT_IN: {
      confirmation: ["owner"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      follow_up1: ["owner"],
      after_appointment_deal: ["owner"],
      after_appointment_no_deal1: ["owner"],
      after_appointment_no_deal2: ["owner"],
      after_appointment_no_deal3: ["owner"],
    },
    PRESENT_ESTIMATION_BUY_IN: {
      confirmation: ["owner"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      after_appointment: ["owner", "representative"],
      follow_up1: ["representative"],
      follow_up2: ["representative"],
      after_appointment_deal: ["owner", "representative"],
    },
    PRESENT_ESTIMATION_RENT_IN: {
      confirmation: ["owner"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      after_appointment: ["owner", "representative"],
      follow_up1: ["representative"],
      follow_up2: ["representative"],
      after_appointment_deal: ["owner", "representative"],
    },
    BUY_IN: {
      confirmation: ["owner", "representative"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      after_appointment_deal: ["owner", "notary", "representative"],
      after_appointment_no_deal1: ["owner"],
      after_appointment_no_deal2: ["owner"],
      after_appointment_no_deal3: ["owner"],
      follow_up1: ["owner", "representative"],
      follow_up2: ["owner", "representative"],
      follow_up3: ["owner", "representative"],
      follow_up4: ["owner", "representative"],
      follow_up5: ["owner", "representative"],
    },
    BUY_IN_OFFICE: {
      confirmation: ["owner", "representative"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      after_appointment_deal: ["owner", "notary", "representative"],
      after_appointment_no_deal1: ["owner"],
      after_appointment_no_deal2: ["owner"],
      after_appointment_no_deal3: ["owner"],
      follow_up1: ["owner", "representative"],
      follow_up2: ["owner", "representative"],
      follow_up3: ["owner", "representative"],
      follow_up4: ["owner", "representative"],
      follow_up5: ["owner", "representative"],
    },
    RENT_IN: {
      confirmation: ["owner"],
      reminder1: ["owner"],
      reminder2: ["owner"],
      after_appointment_deal: ["owner"],
      follow_up1: ["owner", "representative"],
    },
    PHOTO: {
      confirmation: ["owner"],
    },
  },
  DEAL: {
    UNDER_OFFER_SALE: {
      in_option: ["buyer", "owner", "representative"],
      reserved: ["buyer", "owner", "representative"],
    },
    UNDER_OFFER_SALE_NEW: {
      in_option: ["buyer", "owner", "representative"],
      reserved: ["buyer", "owner", "representative"],
    },
    SOLD: {
      after_sales_agreement: ["buyer", "owner", "representative"],
      sales_agreement: ["buyer", "owner", "representative"],
      review: ["buyer", "owner", "representative"],
      follow_up_deed: ["buyer", "owner", "representative"],
      follow_up_deed2: ["buyer", "owner", "representative"],
    },
    SOLD_NEW: {
      after_sales_agreement: ["buyer", "owner", "representative"],
      sales_agreement: ["buyer", "owner", "representative"],
      review: ["buyer", "owner", "representative"],
      follow_up_deed: ["buyer", "owner", "representative"],
      follow_up_deed2: ["buyer", "owner", "representative"],
    },
    UNDER_OFFER_RENT: {
      in_option: ["future_renter", "representative", "owner"],
    },
    RENTED: {
      rental_agreement: ["future_renter", "owner", "representative"],
      review: ["future_renter", "owner", "representative"],
    },
  },
  MARIAGE: {
    MARIAGE: {
      mariage: ["visitor"],
    },
  },
  LISTING_LIVE: {
    LISTING_ONLINE_SALE: {
      confirmation: ["owner", "representative"],
    },
    LISTING_ONLINE_RENT: {
      confirmation: ["owner", "representative"],
    },
  },
  ACTIVITY_REPORT: {
    ACTIVITY_REPORT: {
      "activity-report": ["representative"],
    },
  },
  INVALID_DATA: {
    INVALID_DATA: {
      warning: ["representative"],
    },
  },
  CANCELLATION: {
    CANCELLATION: {
      confirmation: ["visitor"],
    },
  },
};
